import type { SigningStatus } from "@/shared/types";

interface OrgSignedPatch {
  status: SigningStatus;
  status_display: string;
  org_signed_at: string;
}

interface FullySignedPatch {
  status: SigningStatus;
  status_display: string;
  counter_signed_at: string;
}

export function createOrgSignedPatch(): OrgSignedPatch {
  return {
    status: 1,
    status_display: "Signed by organization",
    org_signed_at: new Date().toISOString(),
  };
}

export function createFullySignedPatch(): FullySignedPatch {
  return {
    status: 3,
    status_display: "Fully signed",
    counter_signed_at: new Date().toISOString(),
  };
}
